import { Resource } from 'modules/core/base-resource';
import httpResource from 'modules/core/http-resource';

interface LocationImageResponse {
  id: number;
  image: string;
  ordinalNumber: number;
}

class LocationsResource extends Resource {
  constructor() {
    super('location', httpResource);
  }

  public async uploadImage(image: File | string, locationId: number, ordinalNumber: number): Promise<LocationImageResponse> {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('ordinalNumber', ordinalNumber.toString());

    return await this.child(`${locationId}/image`).post<LocationImageResponse>(formData);
  }

  public async deleteImage(locationId: number, imageId: number): Promise<LocationImageResponse> {
    return await this.child(`${locationId}/image/${imageId}`).delete();
  }

  public async updateImagesOrder(
    locationId: number,
    images: { imageId: number; ordinalNumber: number }[],
  ): Promise<LocationImageResponse> {
    return await this.child(`${locationId}/images`).put<LocationImageResponse>(images);
  }
}

const locationsResource = new LocationsResource();
export default locationsResource;
